export const TEXT_NODE_TEXT_BLOCK = 'textBlock';
export const TEXT_NODE_SHAPE = 'textShape';
export const TEXT_NODE_PANEL = 'textNodePanel';
